import {ThemeContext} from "@radix-ui/themes";
import {Context, useContext} from "react";
import {ThemeContextValue} from "./Theme";

export default function useTheme(): ThemeContextValue {
    // @ts-ignore
    return useContext(ThemeContext as Context<ThemeContextValue>);
}